import { environment } from 'src/environments/environment';
import { Desenvolvedor } from '../desenvolvedor';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DesenvolvedorService {

  constructor(private http: HttpClient) { }

  private baseUrl = environment.urlApi + '/api/desenvolvedores/';

  public getDesenvolvedor(id: string): Observable<Desenvolvedor> {
    const urlApi = this.baseUrl + id;
    return this.http.get<Desenvolvedor>(urlApi);
  }

}
